import React from 'react'
import Navigation from './Navigation'


export interface PageProps {
  children: React.ReactNode
}

export default function Page({children}: PageProps) {
  return (
    <div>
      <Navigation />

      {children}
    </div>
  )
}
